import { IMUnit } from '../../types'
import { createNoteNode } from '../createNodeWrappers'
import { createActivity, createNodeList } from '../../../nodeCreationHelpers'

const title = 'Family Support Materials'

export function sectionFamilySupportMaterials(
  ordinalTitle: string,
  content: {
    sectionFamilySupport?: string
    unitFamilySupport?: string
  },
) {
  const value = familySupportContent(ordinalTitle, content)
  if (!value) return []
  return [createNodeList({ title }, [familySupportActivity(value)])]
}

export function unitFamilySupportMaterials({
  family_support_materials,
}: IMUnit) {
  if (!family_support_materials) return []
  return [
    createNodeList({ title }, [
      familySupportActivity(family_support_materials),
    ]),
  ]
}

export function familySupportActivity(value: string) {
  return createActivity(
    {
      title,
      assignment: 'participation',
      assessment_grading: 'formative',
    },
    contentNote(value),
  )
}

function contentNote(value: string) {
  return [createNoteNode({ title, value, studentFacing: true })]
}

function familySupportContent(
  ordinalTitle: string,
  {
    sectionFamilySupport,
    unitFamilySupport,
  }: {
    sectionFamilySupport?: string
    unitFamilySupport?: string
  },
) {
  // Found in section content (Grade 6)
  if (sectionFamilySupport?.trim()) return sectionFamilySupport.trim()

  // Found in unit content, but needs to be parsed out (Grade 1)
  const marker = `<h3>${ordinalTitle}</h3>`
  const withSectionContent = unitFamilySupport?.split(marker).pop()
  const [, ...contentParts] =
    withSectionContent?.split('<h3>Section')[0]?.split('</h3>') ?? []
  return contentParts.join('')
}
